import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-modal"
export default class extends Controller {
  static targets = ["modal", "backdrop"]

  connect() {
    // Start hidden
    this.element.style.transition = 'opacity 200ms ease-in-out'
    this.element.style.opacity = '0'
    this.element.style.pointerEvents = 'none'
  }

  disconnect() {
    // Restore body scroll
    document.body.style.overflow = ''
  }

  open() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden'

    // Show modal
    this.element.style.pointerEvents = 'auto'

    // Fade in animation
    requestAnimationFrame(() => {
      this.element.style.opacity = '1'
    })
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    // Restore body scroll
    document.body.style.overflow = ''

    // Fade out animation
    this.element.style.opacity = "0"
    this.element.style.pointerEvents = 'none'
  }

  // Close on backdrop click
  closeOnBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  // Close on Escape key
  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
